import { VehicleInfoData } from '../../dtos';
const manualSelectClicked = (state, action) => {
    return Object.assign(new VehicleInfoData(), {
        VehicleSelectionMethod: action.payload.vehicleSelectionMethod,
        Vin: action.payload.vehicleInfo.Vin
    });
};
export default manualSelectClicked;
//# sourceMappingURL=manualSelectClicked.js.map